
import React, { useEffect, useState } from 'react'
import ReactHtmlParser from 'react-html-parser'; 

import { getSizedImageUrl } from '../../../../../scripts/utils/image'
import { ISubBuilderProduct } from '../../../../context/subBuilder/types';

import { useSubBuilder } from '../../../../context/subBuilder/useSubBuilder'
import Money from '../../../Money';
import Price from '../../../Price'
import GreyBoxYellowBoxSwitcheroo from '../components/GreyBoxYellowBoxSwitcheroo';

import SubBuilderStep from '../components/SubBuilderStep';

const Roast: React.FunctionComponent = () => {
  const { settings, state, actions } = useSubBuilder()

  const [giftProducts, setGiftProducts] = useState<ISubBuilderProduct[]>([])
  const [discoveryProducts, setDiscoveryProducts] = useState<ISubBuilderProduct[]>([])
  const [traditionalProducts, setTraditionalProducts] = useState<ISubBuilderProduct[]>([])
  const [bothProducts, setBothProducts] = useState<ISubBuilderProduct[]>([])
  const { fromText } = window['theme'].strings
  useEffect(() => {
    const discoveryProducts = []
    const traditionalProducts = []
    const bothProducts = []
    settings.products['gift'].forEach(product => {
      if (product.blockType === 'gift_product_both') {
        bothProducts.push(product)
      } else if (product.blockType === 'gift_product_traditional') {
        traditionalProducts.push(product)
      } else if (product.blockType === 'gift_product') {
        discoveryProducts.push(product)
      } else {
        console.error('Please check the names for the products set in the customiser contain the above flags.')
      }
    })
    setGiftProducts([discoveryProducts[0], traditionalProducts[0], bothProducts[0]].filter(Boolean))
    setDiscoveryProducts(discoveryProducts)
    setTraditionalProducts(traditionalProducts)
    setBothProducts(bothProducts)
  }, [])

  return (
    <SubBuilderStep className="sub-builder-container sub-builder-roast" index={2} stepConfig={settings.steps.roast}>
      <>
        {state.subscriptionType === 'me'
          ? settings.products[state.subscriptionType].map(({ product, title }, i) => (
            <button className="sub-builder-btn-roast sub-builder-btn" id={`sub-builder-btn-roast-${i}`} key={product.handle} type="button" onClick={() => {
              const isBothProducts = product.tags.includes('subscription-both')

              actions.setIsBothProducts(isBothProducts)
              actions.setProductHandle(product.handle)
              actions.moveStep(+1)
            }}>
              <GreyBoxYellowBoxSwitcheroo className="sub-builder-btn-img sub-builder-roast-img">
                {product.featured_image && <img src={getSizedImageUrl(product.featured_image, '300x300')} data-lazy-load /> }
              </GreyBoxYellowBoxSwitcheroo>
              <div className="sub-builder-btn-content">
                <div className="sub-builder-btn-header">
                  <span className="sub-builder-btn-title">{title}</span>
                  <Price
                    finalPrice={product.price}
                    originalPrice={product.compare_at_price ? product.compare_at_price : product.price}
                    priceVaries={Boolean(product.price_varies)}
                    priceMin={ product.min_price ? product.min_price : product.price }
                  />
                </div>
                <div className="sub-builder-btn-roast-desc">{ ReactHtmlParser(product.description) }</div>
              </div>
            </button>
        
          )) 
          : giftProducts.map(({ product, title }, i) => (
            <button className="sub-builder-btn-roast sub-builder-btn" id={`sub-builder-btn-roast-${i}`} key={product.handle} type="button" onClick={() => {
              let products;
              const foundDiscoveryProduct = discoveryProducts.find(prod => prod.product.handle === product.handle);
              const foundTraditionalProduct = traditionalProducts.find(prod => prod.product.handle === product.handle);
              let isBothProducts = false;
              if (foundDiscoveryProduct) {
                products = discoveryProducts;
              } else if (foundTraditionalProduct) {
                products = traditionalProducts;
              } else {
                products = bothProducts;
                isBothProducts = true;
              }
            
              const productHandles = products.map(prod => prod.product.handle)
              actions.setProductHandles(productHandles)
              actions.setIsBothProducts(isBothProducts)
              actions.moveStep(+1)
            }}>
              <GreyBoxYellowBoxSwitcheroo className="sub-builder-btn-img sub-builder-roast-img">
                {product.featured_image && <img src={getSizedImageUrl(product.featured_image, '300x300')} data-lazy-load /> }
              </GreyBoxYellowBoxSwitcheroo>
              <div className="sub-builder-btn-content">
                <div className="sub-builder-btn-header">
                  <span className="sub-builder-btn-title">{title.split(' ')[0]}</span>
                  <p className="product-price">
                    {fromText} <Money amount={product.price} />
                  </p>
                </div>
                <div className="sub-builder-btn-roast-desc">{ ReactHtmlParser(product.description) }</div>
              </div>
            </button>
          ))}
      </>
    </SubBuilderStep>
  )
}
export default Roast
